import { ReactNode } from "react";
import { spMode } from "@/hooks";
import { color } from "@/styles/theme";

// Adapted from mfx_biz_react_components.
// https://github.com/moneyforward/mfx_biz_react_components/blob/89d88f5b2c2c9fabc7704258c4e7c8841c2e9b13/src/components/Header/BankLogo.tsx
//
// This is necessary because they hard-code the width of the image, making it
// impossible to handle logos of different aspect ratios.
//
// I've raised an issue, if they agree and make my suggested changes, we can
// delete this and go back to using Header.BankLogo.

const bankLogoContainer = {
  height: 24,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  [spMode]: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: 40,
    backgroundColor: color.white,
  },
};

const BankLogo = ({
  src,
  alt = "Bank Logo",
  children,
  ...rest
}: {
  src: string;
  alt?: string;
  children?: ReactNode;
}) => {
  return (
    <div css={bankLogoContainer} {...rest}>
      {src ? (
        <img
          src={src}
          alt={alt}
          css={{
            height: 24,
          }}
        />
      ) : (
        <div
          css={{
            maxWidth: 150,
            maxHeight: 24,
            position: "relative",
          }}
        >
          {children}
        </div>
      )}
    </div>
  );
};

export default BankLogo;
